import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/home/home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/joinus',
      name: 'Joinus',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/joinus'),
    },
    {
    	path: '/details',
      name: 'details',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/details/details'),
    },
    {
    	path: '/details1',
      name: 'details1',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/details/details1'),
    },
    {
    	path: '/details2',
      name: 'details2',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/details/details2'),
    },
    {
    	path: '/details3',
      name: 'details3',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/details/details3'),
    },
    {
    	path: '/details4',
      name: 'details4',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/details/details4'),
    },
    {
    	path: '/details5',
      name: 'details5',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/joinus/details/details5'),
    },
    {
      path: '/solution',
      name: 'Solution',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/solution/solution')
    },
    {
      path: '/contactus',
      name: 'Contactus',
      component: () => import (/*webpackChunkName: "SnsPageRecommend"*/ '@/pages/contactus/contactus')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js